import api from './api';

export const getGroupSetupContent = async () => {
  const response = await api.get('/group-setup-content');
  return response.data;
};

export const updateGroupSetupContent = async ({ title, warningText, descriptionText, badgeText }) => {
  const response = await api.put('/group-setup-content/admin', { title, warningText, descriptionText, badgeText });
  return response.data;
};
